import React from 'react';
import Styles from './styles.js';
import HeadingSectionV1 from 'components/v1-tailwindcss/HeadingSectionV1';
import ButtonV1 from '../ButtonV1';
import Link from 'next/link';
const data2 = [
    {
        id: 1,
        image: "/static/images/landingPages/ForLandlords/cashflows.png",
        discrip: "Unlock a new dimension of convenient renting for modern renters. Our proprietary technology gives you the ability to rent properties by the room in addition to the traditional form of renting.",
        href:"/renters"

    },
    {
        id: 2,
        image: "/static/images/landingPages/ForLandlords/vacancies.png",
        discrip: "Rent 3X faster than the market with integrated leasing CRM to manage and communicate with all your leads. Maximize occupancy, customer satisfaction, and lead-to-lease conversions.",
        href:"/reduce-vacancies-with-sr"

    },
    {
        id: 3,
        image: "/static/images/landingPages/ForLandlords/price.png",
        discrip: "We’ve taken the guesswork out of pricing. Our rent estimator calculates rent based on location, quality of the home, sqft, appliances,amenities, and more. Yes, you can use it for pricing the rooms as well. ",
        href:"/price-correctly-with-sr"


    },
    {
        id: 4,
        image: "/static/images/landingPages/ForLandlords/tenant.png",
        discrip:"Advanced AI that goes beyond credit and identity checks. Our system can calculate a prospects monthly cashflow using secured banking data to ensure a detailed screening process.  ",
        href:"/renters"


    },
    {
        id: 5,
        image: "/static/images/landingPages/ForLandlords/communicate.png",
        discrip: "Centrally manage and link key property management functionswith more effective tenant communications. You can communicate in batches to anyone or everyone for maintenance scheduling, notices, and more.",
        href:"/communicate-with-sr"


    },
]


const UseCasesV1 = () => {
    return (
        <>

            <div className='lg:container px-6  mx-auto pt-12 mb-6'>
                <HeadingSectionV1 title='SOULROOMS IS LIKE REDBULL, IT GIVES YOU WINGS!' />

                <div className='flex  justify-center items-center xl:px-8 lg:px-4 gap-y-8 md:gap-y-4 flex-wrap'>
                    {data2.map((data) => {
                        const { id, image, discrip,href } = data;

                        return (
                            <div style={{minHeight:"630px"}} key={id} className=' px-6 lg:w-1/3 md:w-2/4 w-full text-center flex flex-col justify-between'>
                                <img src={image} className='w-full' />
                                <p className='usecase_para md:my-8 my-5 text-lg'>{discrip}</p>
                                <div className='w-full flex justify-center'>
                                    <Link href={href}>
                                    <ButtonV1
                                        btnHref={href}
                                        btnName="Check out Use Cases"
                                        px="px-9"
                                        py="py-4"
                                        txtColor="rgb(1, 1, 1)"
                                    />
                                    </Link>


                                </div>


                            </div>
                        )
                    })}

                </div>

            </div>
            <Styles/>

        </>
    );
};

export default UseCasesV1;
